import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxReport from '../util/remote/ajaxReport';

const initialState = { 
    statement: null,
    metaData: null,
    currentPage: 1,
    dateRange: { opening_date: "", closing_date: "" },
    mounted: false,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const CashFlowContext = createContext();

export const CashFlowProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  /**
   * Only call this if the getTransactions has already been called on mount by the AccountStatementPage
   */
  useEffect(()=>{
    if(state.mounted){
      getStatement();
    }
  }, [state.currentPage])

 

  const getStatement = async (refresh = false, period = null, specificDates = null) => {
    dispatch({ type: "mounted", payload: true });

    if (refresh) {
        dispatch({ type: "statement", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
    }

    const server_response = await ajaxReport.fetchDailyCashFlow({
        page: refresh ? 1 : state.currentPage,
        opening_date: period?.opening_date || state.dateRange?.opening_date,
        closing_date: period?.closing_date || state.dateRange?.closing_date,
        specific_dates: specificDates
    });

    if (server_response.status === "OK") {
        dispatch({ type: "statement", payload: server_response.details });
    } else {
        dispatch({ type: "statement", payload: "404" });
    }
};

  

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }


  return(
    <CashFlowContext.Provider value={{
      ...state, 
      dispatch,
      getStatement,
      setCurrentPage 
      }}>
      {children}
    </CashFlowContext.Provider>
  )

}

export const useCashFlow = ()=>useContext(CashFlowContext);

